if (
  typeof Object !== undefined
  && Object.prototype
  && !Object.prototype.ppDump
) {
  Object.defineProperty(Object.prototype, 'ppDump', {
    value({
      includeObject = false,
      includeKeys = true,
      includePrototype = true,
      includePropertyNames = true,
    } = {}) {
      return {
        ...includeObject && { object: this },
        ...includeKeys && { keys: Object.keys(this) },
        ...includePrototype && { prototype: Object.getPrototypeOf(this) },
        ...includePropertyNames && { propertyNames: Object.getOwnPropertyNames(this) },
      };
    }
  });
}